import * as locales from "date-fns/locale";

export const getLocale = () => {
  const language = window?.navigator?.language;
  if (language) {
    const locale = language.split("-").join("");
    return locales[locale];
  }

  return undefined;
};
